export class PlatformSettings {
  id: number;
  platformName: string;
  sendOutEmailName: string;
  sendOutEmailDomain: string;
  logo: number;
  chartColors: string[] = new Array<string>(10);
  platformBgColor: string;
  bottombarBgColor: string;
  bottombarButtonColors: string[] = new Array<string>(4);
  emailBgColor: string;
  emailButtonColors: string[] = new Array<string>(2);

  // this field only use in fontend
  logoContent: any;
}



// WEBPACK FOOTER //
// ./src/models/platform-settings/platform-settings.ts